import {API_URL_FINTECH} from '../constants';

export const apiBaseCards = {
  baseUrl: API_URL_FINTECH,
  endpoints: {
    getCardThemes: '/card/v1/themes',
    getCardThemesV2: '/card/v2/themes',
  },
};
